<template lang="pug">
  .contenedor
    header
      .information
        img(src='/static/libro-reclamaciones.png')
      .logo
        img(:src='logo')
      .section(key="accion")
        .boton-enviar
          a.button.is-empresa(
            :class="{'is-loading': isSending}"
            @click="send"
          )
            span.icon.is-small
              i.fa.fa-send-o
            span Enviar reclamo
      //- pre {{ local }}
      //- pre {{ consumidor }}
      //- pre {{ bien }}
      //- pre {{ detalle }}

    section.body
      transition-group.contenedor-transition.contenedor-sections(name="fade-smooth", tag="div")
        .section.box(key="seleccionar-local")
          box-seleccionar-local(@selected="asignarLocal", ref="local")
        .section.box(key="ingresar-datos-consumidor")
          box-ingresar-datos-consumidor(@send="asignarConsumidor", ref="consumidor")
        .section.box(key="identificacion-bien-contratado")    
          box-identificacion-bien-contratado(@send="asignarBien", ref="bien")
        .section.box(key="detalle-pedido-consumidor")    
          box-detalle-pedido-consumidor(@send="asignarDetalle", ref="detalle")
        
        div(key="recaptcha")
          vue-recaptcha.recaptcha-container(
            ref="recaptcha"
            @verify="onVerify"
            @expired="onExpired"
            :sitekey="sitekey"
          )
          
        .section(key="accion")
          .boton-enviar
            a.button.is-empresa(
              :class="{'is-loading': isSending}"
              @click="send"
            )
              span.icon.is-small
                i.fa.fa-send-o
              span Enviar reclamo

    notifications  

              
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';
import BoxSeleccionarLocal from './Box-1-seleccionar-local.vue'
import BoxIngresarDatosConsumidor from './Box-2-ingresar-datos-consumidor.vue'
import BoxIdentificacionBienContratado from './Box-3-identificacion-bien-contratado.vue'
import BoxDetallePedidoConsumidor from './Box-4-detalle-pedido-consumidor.vue'
import { apiPost, notify } from '../util/general'
export default {
  name: 'registrar',
  components: {
    VueRecaptcha,
    BoxSeleccionarLocal,
    BoxIngresarDatosConsumidor,
    BoxIdentificacionBienContratado,
    BoxDetallePedidoConsumidor
  },
  data () {
    return {
      local           : {},
      consumidor      : {},
      bien            : {},
      detalle         : {},
      isSending       : false,
      requestRoute    : '',
      verifyRecaptcha : '',
      sitekey         : 'fer',
      logo            : '/static/logo.png'
      // local: {
      //   'codigo': 1,
      //   'descripcion': 'Halcones',
      //   'direccion': 'Av. Halcones 445 Surquillo Lima'
      // },
      // consumidor: {
      //   'dni': '71407846',
      //   'nombre': 'Fernando Benavides',
      //   'email': 'fbenavides@datacont.com',
      //   'direccion': 'Jr. Cipriano Rivas 546 San Juan de Miraflores',
      //   'telefono': '988880026',
      //   'nombrePadre': 'Carola'
      // },
      // bien: {
      //   'tipo': 'producto',
      //   'moneda': 'soles',
      //   'monto': '1000',
      //   'descripcion': 'Scanner DR300'
      // },
      // detalle : {
      //   'tipo': 'reclamo',
      //   'descripcion': 'Cuando Scannea no funciona\nPero ellos dicen que es mi culpa por haberle echado agua\npero en ningun momento en el manual dice que no debo echarle agua, fue un accidente',
      //   'pedido': 'Que me den un nuevo Scanner sin costo adicional'
      // }
    }
  },
  created () {
    this.requestRoute = process.env.API_ROUTE
    this.sitekey      = process.env.RECAPTCHA_KEY
  },
  methods: {
    asignarLocal (o) {
      this.local = o
    },
    asignarConsumidor (o) {
      this.consumidor = o
    },
    asignarBien (o) {
      this.bien = o
    },
    asignarDetalle (o) {
      this.detalle = o
    },
    send () {
      let vm = this
      this.isSending = true
      this.requestRoute = process.env.API_ROUTE
      let obj = {
        local      : vm.local,
        consumidor : vm.consumidor,
        bien       : vm.bien,
        detalle    : vm.detalle
      }

      let textoError = this.validar(vm, obj)
      if (textoError) {
        vm.isSending = false
        notify(vm, 'error', 'Error', textoError)
        return
      }
      // vm.notify('success', 'Éxito', 'Su reclamo fue enviado correctamente')
      // return
      apiPost(vm, '/libroreclamaciones', obj, function (data) {
        vm.isSending = false
        vm.clean()
        notify(vm, 'success', 'Éxito', 'Su reclamo fue enviado correctamente')
        var url = vm.requestRoute + '/libroreclamaciones/pdf?empresa=' + process.env.EMPRESA + '&preimpreso=' + data.preimpreso + '&dni=' + data.dni
        console.log('url:', url)
        var link    = document.createElement('a');
        link.href   = url
        link.target = '_blank'
        link.click();
      }, function (error) {
        console.log(error);
        vm.isSending = false
        notify(vm, 'error', 'Error', 'Su reclamo no pudo ser enviado')
      })
    },
    validar (vm, obj) {
      // Validamos que el captcha haya sido presionado
      if (!vm.verifyRecaptcha) {
        return 'Por favor de click al reCAPTCHA '
      }

      // Validamos que haya seleccionado un local
      if (!(obj.local && obj.local.codigo)) {
        return 'Por favor seleccione el local de la empresa donde se encuentra'
      }

      // Validamos los datos del consumidor
      if (obj.consumidor) {
        if (!obj.consumidor.dni) return 'Por favor ingrese su DNI'
        if (!obj.consumidor.nombre) return 'Por favor ingrese su nombre completo'
        if (!obj.consumidor.email) return 'Por favor ingrese su email'
        if (!obj.consumidor.direccion) return 'Por favor ingrese su dirección'
        if (!obj.consumidor.telefono) return 'Por favor ingrese su teléfono'
      } else return 'Por favor ingrese los datos del consumidor'

      // Validamos los datos del bien contratado
      if (obj.bien) {
        if (!obj.bien.tipo) return 'Por favor seleccione un tipo de bien contratado'
        if (!obj.bien.monto) return 'Por favor ingrese un monto del bien contratado'
        if (!obj.bien.moneda) return 'Por favor seleccione una moneda para el monto del bien contratado'
        if (!obj.bien.descripcion) return 'Por favor ingrese una explicación acerca del ' + obj.bien.tipo + ' contratado'
      } else return 'Por favor ingrese los datos del bien contratado'

      // Validamos los datos del detalle de reclamacion
      if (obj.detalle) {
        if (!obj.detalle.tipo) return 'Por favor seleccione un tipo de reclamación'
        if (!obj.detalle.descripcion) return 'Por favor detalle su reclamo'
        if (!obj.detalle.pedido) return 'Por favor ingrese su pedido para ayudarnos a mejorar'
      } else return 'Por favor ingrese los datos del detalle de la reclamacion'

      return ''
    },
    onVerify: function (response) {
      console.log('Verify: ' + response)
      this.verifyRecaptcha = response
    },
    onExpired: function () {
      console.log('Expired')
      this.verifyRecaptcha = ''
    },
    resetRecaptcha () {
      this.$refs.recaptcha.reset() // Direct call reset method
      this.verifyRecaptcha = ''
    },
    clean () {
      this.local = {}
      this.consumidor = {}
      this.bien = {}
      this.detalle = {}
      this.$refs.local.clean()
      this.$refs.consumidor.clean()
      this.$refs.bien.clean()
      this.$refs.detalle.clean()
    }
  }
}
</script>

<style lang="stylus" scoped>
  html, body
    overflow-y hidden

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    padding-top: 60px;
    display: flex;
    justify-content: center;
    max-height: calc( 100vh - 0px );
    overflow-y: hidden;
  }
  
  .fade-smooth-enter, .fade-smooth-leave-active {
    opacity: 0;
    transform: translateY(-10px);
  }

  .fade-smooth-leave-active {
    position: absolute;
  }
  
  .contenedor-transition
    >*
      transition: all 0.5s;

  .contenedor
    padding 5px 50px
    display flex

  header
    display flex
    flex-direction column
    align-items center
    margin-right 20px
    .logo
      img 
        width: 191px;

    .information
      width: 260px;
    
  .body
    text-align left
    overflow-y auto
    padding: 10px;
    
  //Titulo y explicacion de cada section
  section.header
    h2
      font-weight bold
      font-size: 23px;
      margin-bottom 0px !important
    p
      font-size 16px
      color #a9a7a7
      margin-top 5px
    hr
      margin-top 7px
  
  .checkbox
    span 
      margin-left 10px
  
  .boton-enviar
    text-align center
  
  .recaptcha-container
    display flex 
    justify-content center
  
  //Select box, las que se pintan de rojo
  .select-box
    display flex
    .option
      cursor pointer
      border 3px solid #ccc
      flex 1
      margin 10px
      display flex
      flex-direction column
      align-items center
      padding 5px
      transition all ease 0.3s
      border-radius 5px
      &:hover
        background-color #eae8e8
      .codigo
        font-size 13px
        color #bebebe
      .descripcion
        font-size 17px
        font-weight bold
  
  .description-box
    margin-top 5px
    strong
      min-width 150px
      display: inline-block;
  
  //Field con label a la izquierda
  .field
    display flex
    align-items center
    label
      font-size 14px
      margin-bottom 0px
      width 200px
      padding-right 10px
    .control
      flex 1
      input
        font-size 14px
        height 25px
    
</style>



// WEBPACK FOOTER //
// View_Registrar.vue?4b1e8088